import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import FileList from '../views/FileList.vue'
import BIM_LibraryMarket from '../views/BIM_LibraryMarket.vue'
import BIM_LibraryMarketView from '../views/BIM_LibraryMarketView.vue'
import DesignSimulation from '../views/DesignSimulation.vue'
import DesignSimulationView from '../views/DesignSimulationView.vue'
import MaintenancePage from '../views/MaintenancePage.vue'
import MaintenanceView from '../views/MaintenanceView.vue'
import MaintenanceWrite from '../views/MaintenanceWrite.vue' 
import ZEB_Manufacturer from '../views/ZEB_Manufacturer.vue'
import ZebRegister from '../views/ZebRegister.vue'
import BIPV_Modul from '../views/BIPV_Modul.vue'
import OnlineSeminar from '../views/OnlineSeminar.vue'
import InquireView from '../views/InquireView.vue'
import InquireForm from '../views/InquireForm.vue'
import InquireHistory from '../views/InquireHistory.vue'
import LoginForm from '../views/LoginForm.vue' 
import RegisterForm from '../views/RegisterForm.vue'
import PointHistory from '../views/PointHistory.vue'
import NewMain from '../views/NewMain.vue'

const routes = [
  {
    path: '/',        
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/file',
    name: 'FileList',
    component: FileList
  },
  {
    path: '/bim_library_market',
    name: 'BIM_LibraryMarket',
    component: BIM_LibraryMarket
  },
  {
    path: '/bim_library_market_view',
    name: 'BIM_LibraryMarketView',
    component: BIM_LibraryMarketView
  },
  {
    path: '/design_simulation',
    name: 'DesignSimulation',
    component: DesignSimulation
  },
  {
    path: '/design_simulation_view',
    name: 'DesignSimulationView',
    component: DesignSimulationView
  },
  {
    path: '/maintenance',
    name: 'MaintenancePage',
    component: MaintenancePage
  },
  {
    path: '/maintenance_view',
    name: 'MaintenanceView',
    component: MaintenanceView
  },
  {
    path: '/maintenance_write',
    name: 'MaintenanceWrite',
    component: MaintenanceWrite
  },
    {
    path: '/zeb_manufacturer',
    name: 'ZEB_Manufacturer',
    component: ZEB_Manufacturer
  },
  {
    path: '/online_seminar',
    name: 'OnlineSeminar',
    component: OnlineSeminar
  },
  {
    path: '/bipv_modul',
    name: 'BIPV_Modul',
    component: BIPV_Modul
  },
  {
    path: '/inquire_view',
    name: 'InquireView',
    component: InquireView
  },
  {
    path: '/inquire_form',
    name: 'InquireForm',
    component: InquireForm
  },
  {
    path: '/inquire_history',
    name: 'InquireHistory',
    component: InquireHistory
  },
  {
    path: '/login_form',
    name: 'LoginForm',
    component: LoginForm
  },
  {
    path: '/register_form',
    name: 'RegisterForm',
    component: RegisterForm
  },
  {
    path: '/zeb_register',
    name: 'ZebRegister',
    component: ZebRegister
  },
  {
    path: '/point_history',
    name: 'PointHistory',
    component: PointHistory
  },
  {
    path: '/newmain',
    name: 'NewMain',
    component: NewMain
  } 
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router